export const PROPERTY_TYPE = "PROPERTY_TYPE";
export const PROVINCE = "PROVINCE";
export const REGION = "REGION";
